// src/components/dashboard/HyperDeliveryList.jsx
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { fetchBookings } from '../../store/reducers/HyperDeliveryReducer'

export default function HyperDeliveryList() {
  const dispatch = useDispatch()
  const { bookings, loading, error } = useSelector(s => s.hyperDeliveryList)

  useEffect(() => {
    dispatch(fetchBookings())
  }, [dispatch])

  if (loading)   return <p className="p-4">Loading your deliveries…</p>
  if (error)     return <p className="p-4 text-red-500">Error: {error}</p>
  if (!bookings.length) return <p className="p-4">You have no hyper-delivery bookings yet.</p>

  return (
    <div className="overflow-auto p-4 bg-white rounded shadow">
      <h3 className="text-2xl font-semibold mb-4">
        Your Hyper-Delivery Bookings
      </h3>
      <table className="min-w-full table-auto">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-left">Ordered On</th>
            <th className="px-4 py-2 text-left">Pickup</th>
            <th className="px-4 py-2 text-left">Drop</th>
            <th className="px-4 py-2 text-right">Charged (₹)</th>
            <th className="px-4 py-2 text-left">Current Status</th>
            <th className="px-4 py-2 text-center">Details</th>
          </tr>
        </thead>
        <tbody>
          {bookings.map(b => (
            <tr key={b._id} className="border-b hover:bg-gray-50">
              <td className="px-4 py-2">
                {new Date(b.createdAt).toLocaleDateString()}<br/>
                <span className="text-sm text-gray-500">
                  {new Date(b.createdAt).toLocaleTimeString()}
                </span>
              </td>
              <td className="px-4 py-2">{b.pickupAddress?.raw || '—'}</td>
              <td className="px-4 py-2">{b.dropAddress?.raw   || '—'}</td>
              <td className="px-4 py-2 text-right">
                {(b.amountPaid ?? 0).toFixed(2)}
              </td>
              <td className="px-4 py-2 capitalize">{b.status}</td>
              <td className="px-4 py-2 text-center">
                <Link
                  to={`/dashboard/hyper-delivery/${b.orderId}`}
                  className="inline-block px-3 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700 transition"
                >
                  More Details
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
